export default {
  // Lỗi ghi sổ thông thường
  Post: 0,
  // Lỗi ghi sổ không xác định
  PostException: 1,
  // Lỗi Prepare Convert
  Prepare: 2,
  // Lỗi convert bảng
  Table: 3,
  // Lỗi cả partition
  Partition: 4,
};
